module.exports = __webpack_public_path__ + "img/service.56a7d014.png";